import { render } from "./ViewBonCommandeFournisseurPage.vue?vue&type=template&id=3e3bbdfa&ts=true"
import script from "./ViewBonCommandeFournisseurPage.vue?vue&type=script&lang=ts"
export * from "./ViewBonCommandeFournisseurPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__